import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { LinearProgress } from '@mui/material';

export const PROGRESS_BAR_TEST_ID = 'partner-data-gateway-progress-bar';

export interface ProgressBarProps {
  completed: number;
  total: number;
  testId?: string;
}

/**
 * Batch completion progress for an ingestion, e.g. `completedBatches` /
 * `totalBatches` from `IngestionSummary`.
 *
 * The caption is a sibling node rather than the bar's accessible name, so
 * the bar carries its own `aria-label` — otherwise a screen reader
 * announces a bare percentage with no context.
 */
export const ProgressBar = ({
  completed,
  total,
  testId = PROGRESS_BAR_TEST_ID,
}: ProgressBarProps): JSX.Element => {
  const percent =
    total > 0 ? Math.min(100, Math.round((completed / total) * 100)) : 0;
  const caption = `${completed} / ${total} batches (${percent}%)`;

  return (
    <HHStack gap={0.5} data-testid={testId}>
      <LinearProgress
        variant="determinate"
        value={percent}
        aria-label={`Batch completion: ${caption}`}
      />
      <HHTypography
        hhVariant="variant-bypass"
        variant="caption"
        color="text.secondary"
      >
        {caption}
      </HHTypography>
    </HHStack>
  );
};
